;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputAttachment', inputAttachment)

  /* @ngInject */
  function inputAttachment () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        description: '@',
        field: '=',
        mandatory: '<',
        onChange: '&',
        onComplete: '&',
        readOnly: '<',
        location: '<'
      },
      templateUrl: '/core/directives/input-attachment/input-attachment-directive.html?$$REVISION$$',
      controller: 'InputAttachmentController'
    }
  }
})()
